import { render } from "./LayoutApp.vue?vue&type=template&id=4ad803e0"
import script from "./LayoutApp.vue?vue&type=script&lang=js"
export * from "./LayoutApp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__